<template>
  <div class="text-center">
    <v-menu>
      <template v-slot:activator="{ attrs, on }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-web</v-icon>
        </v-btn>
      </template>

      <v-list link>
        <v-list-item
          v-for="(item, index) in langs"
          :key="index"
          @click="setLang(item)"
        >
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";

export default {
  name: "menu-change-languages",
  data() {
    return {
      langs: [
        { name: "English", short: "en" },
        // { name: "Deutsch", short: "de" },
        { name: "عربي", short: "ar" },
        // { name: "French", short: "fr" },
      ],
    };
  },
  methods: {
    setLang(val) {
      VueCookies.set("lang", val.short);
      this.$i18n.locale = val.short;
      if (val.short == "ar") this.$vuetify.rtl = true;
      else this.$vuetify.rtl = false;
    },
  },
};
</script>
